import React, { useState } from 'react'
import {
    Grid,
    Button,
    Dialog,
    DialogContent,
    useTheme,
    useMediaQuery,
    TextField
} from "@material-ui/core";

import Services from '../../Services';
import DynamicInput from '../InputComponents/DynamicInput';
import { removeSsnFormating } from '../dummyConstant/DummyConstant';
import { format } from 'date-fns';

const { employee } = Services;



const SsnModal = ({ ssnModalData }) => {

    let { employeeDetails, setMainFlag, mainFlag, open, close } = ssnModalData;
    const theme = useTheme();

    // const [updateSSNNumber, setupdateSSNNumber] = useState(formatSSN(employeeDetails?.ssn))
    const [updateSSNNumber, setupdateSSNNumber] = useState(employeeDetails?.ssn)

    const [SetError, setSetError] = useState("");

    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

    function formatSSN(value) {

        // clean the input for any non-digit values.
        const ssn = value?.toString()?.replace(/[^\d]/g, "");

        if (ssn?.length < 4) {
            return `${ssn}`;
        }
        // if (ssn?.length == 4) {
        //     return `${ssn?.slice(0, 3)}-${ssn?.slice(3, 4)}`;
        // }
        if (ssn?.length <= 5) {
            return `${ssn?.slice(0, 3)}-${ssn?.slice(3)}`;
        }
        return `${ssn?.slice(0, 3)}-${ssn?.slice(3, 5)}-${ssn?.slice(5, 9)}`;
        // return `${phoneNumber.slice(0, 3)}-${phoneNumber.slice(3, 5)}-${phoneNumber.slice(5, 9)}`;
    }

    const onChangeSSNValue = (value, e) => {
        if (value?.length > 11) return
        setError(value, setSetError)
        setupdateSSNNumber(value)
    }
    let fields = [
        { format: true, type: 4, name: "SSN Number", initial: formatSSN(updateSSNNumber), isRequired: true, onChange: onChangeSSNValue, validation: SetError },
    ]
    const setError = (value, setError) => {

        let newVal = removeSsnFormating(value)
        if (/^\d+$/.test(newVal)) {
            if (newVal.length === 9) {
                return setError(null)
            } else {
                return setError("Length must be 9 digits")
            }
        } else {
            return setError("SSN should contain digits only")
        }

    }


    function onUpdateSSN(e) {
        e.preventDefault();

        setError(updateSSNNumber, setSetError)
        if (SetError !== null) {
            return
        }
        let data = {
            id: employeeDetails.id,
            ssn: removeSsnFormating(updateSSNNumber),

        }
        try {
            employee.onUpdateSSN(data).then((certificateData) => {
                setMainFlag(!mainFlag)
                close(false)
            }).catch((err) => {   });
        }
        catch (exc) {
             
        }
    }


    return (
        <Dialog
            fullScreen={fullScreen}
            open={open}
            onClose={() => close(false)}
            className="BroadcastMessageModal LiqTables"
            aria-labelledby="responsive-dialog-title"
        >
            <Button autoFocus onClick={() => close(false)} className="ModalClose">
            </Button>

            <form onSubmit={onUpdateSSN}>
                <DialogContent>
                    <DynamicInput fields={fields} />
                    <Grid xs={12} container justify="center" className="mt30">
                        <Button type="submit" className="LinkButton">Save</Button>
                    </Grid>
                </DialogContent>

            </form>

        </Dialog>
    )
}

export default SsnModal